// extracted by mini-css-extract-plugin
module.exports = {"page-hottest-deals":"hottest-deals_page-hottest-deals__ovB6i","breadcrumb-wrapper":"hottest-deals_breadcrumb-wrapper__9gIb2"};